<div class="content">
  <app-form-cv [jobOffer]="jobOffer" (saveCurriculum)="saveCurriculum($event)"></app-form-cv>
</div>
